import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import menuTag from './modules/menuTag'
import system from './modules/system'
import manage from './modules/manage'
import router from '@/router/router'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    login,
    menuTag,
    system,
    manage
  },

  mutations: {
    save_menu_list () {
      // 登录成功取最新的菜单--------------------------
      const menuList = JSON.parse(sessionStorage.getItem('menuList'))
      console.log(menuList, '调用了添加router方法----------------------------')

      let routers = [
        {
          path: '/',
          name: 'layout',
          redirect: '/home',
          component: () => import('@/views/Index/index.vue'),
          children: [
            {
              path: 'home',
              component: () => import('@/views/home/index'),
            },
          ],
        },
      ]
      menuList.forEach((ele) => {
        routers[0].children.push({ path: ele.path, component: () => import(`@/views/${ele.component}`) })
      })
      console.log(routers, router, 'routersroutersroutersrouterrouterrouterrouterrouterrouter')
      router.addRoutes(routers)
    }
  }
})
export default store
